import React from "react";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Contact } from "./components/contact";

export const SoftwareConsultingPage = ({ data }) => {
  return (
    <>
      <Header data={data.Header} />
      <About data={data.About} />
      <Services data={data.Services} />
      <Contact data={data.Contact} />
    </>
  );
};